import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "row mb-2" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "row mt-2" }
const _hoisted_4 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_5 = { class: "col-sm-8" }
const _hoisted_6 = { class: "row mt-2" }
const _hoisted_7 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_8 = { class: "col-sm-8" }
const _hoisted_9 = { class: "row mt-2" }
const _hoisted_10 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_11 = { class: "col-sm-8" }
const _hoisted_12 = {
  key: 0,
  class: "row mt-2"
}
const _hoisted_13 = {
  for: "currency",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_14 = { class: "col-sm-8" }
const _hoisted_15 = {
  key: 1,
  class: "row mt-2"
}
const _hoisted_16 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_17 = { class: "col-sm-8" }
const _hoisted_18 = {
  key: 2,
  class: "row mt-2"
}
const _hoisted_19 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_20 = { class: "col-sm-8" }
const _hoisted_21 = {
  key: 3,
  class: "row mt-2"
}
const _hoisted_22 = {
  for: "paymentOptions",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_23 = { class: "col-sm-8" }
const _hoisted_24 = {
  key: 4,
  class: "row mt-2"
}
const _hoisted_25 = {
  for: "payOutReceiptsHint",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_26 = { class: "col-sm-8" }
const _hoisted_27 = { class: "text-muted" }
const _hoisted_28 = {
  key: 5,
  class: "row mt-2"
}
const _hoisted_29 = {
  for: "reuseMinCapEnabled",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_30 = { class: "col-sm-8" }
const _hoisted_31 = { class: "form-check form-switch d-flex align-items-center mb-2" }
const _hoisted_32 = { class: "text-muted" }
const _hoisted_33 = { class: "row mt-2" }
const _hoisted_34 = {
  for: "isHidden",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_35 = { class: "col-sm-8" }
const _hoisted_36 = { class: "form-check form-switch d-flex align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormInputWrapper = _resolveComponent("FormInputWrapper")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_CurrencyAmountMapInput = _resolveComponent("CurrencyAmountMapInput")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("form", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.helper.trans("labels.name")) + ":", 1),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_FormInputWrapper, {
              errors: _ctx.getErrors(`name`)
            }, {
              default: _withCtx((parentProps) => [
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass([parentProps.class, "form-control"]),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
                  type: "text",
                  id: "name"
                }, null, 2), [
                  [_vModelText, _ctx.form.name]
                ])
              ]),
              _: 1
            }, 8, ["errors"])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.helper.trans("labels.publicName")) + ":", 1),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_FormInputWrapper, {
              errors: _ctx.getErrors(`publicName`)
            }, {
              default: _withCtx((parentProps) => [
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass([parentProps.class, "form-control"]),
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.publicName) = $event)),
                  type: "text",
                  id: "publicName"
                }, null, 2), [
                  [_vModelText, _ctx.form.publicName]
                ])
              ]),
              _: 1
            }, 8, ["errors"])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.helper.trans("labels.type")) + ":", 1),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_FormInputWrapper, {
              errors: _ctx.getErrors(`type`)
            }, {
              default: _withCtx((parentProps) => [
                _createVNode(_component_Multiselect, {
                  disabled: !!_ctx.form.id,
                  class: _normalizeClass(parentProps.class),
                  modelValue: _ctx.form.type,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.type) = $event)),
                  options: [_ctx.Direction.PAY_IN, _ctx.Direction.PAY_OUT],
                  "custom-label": (opt) => _ctx.helper.trans(`direction.${opt}`),
                  multiple: false,
                  "select-label": "Select",
                  placeholder: ""
                }, null, 8, ["disabled", "class", "modelValue", "options", "custom-label"])
              ]),
              _: 1
            }, 8, ["errors"])
          ])
        ]),
        (_ctx.limitsFieldsVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.helper.trans("labels.currency")), 1),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_FormInputWrapper, {
                  errors: _ctx.getErrors(`currency`)
                }, {
                  default: _withCtx((parentProps) => [
                    _createVNode(_component_Multiselect, {
                      id: "currency",
                      class: _normalizeClass(["", parentProps.class]),
                      modelValue: _ctx.form.currency,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.currency) = $event)),
                      options: _ctx.store.getters['currencyMethods/currencies'],
                      "custom-label": (opt) => `${opt}`,
                      multiple: false,
                      "select-label": "Select",
                      placeholder: ""
                    }, null, 8, ["modelValue", "options", "custom-label", "class"])
                  ]),
                  _: 1
                }, 8, ["errors"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.limitsFieldsVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.helper.trans("labels.min_sum")) + ":", 1),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_FormInputWrapper, {
                  errors: _ctx.getErrors(`minSum`)
                }, {
                  default: _withCtx((parentProps) => [
                    _withDirectives(_createElementVNode("input", {
                      class: _normalizeClass([parentProps.class, "form-control"]),
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.minSum) = $event)),
                      "data-maska": "9.########",
                      "data-maska-tokens": "9:[0-9]:multiple",
                      inputmode: "decimal",
                      type: "text",
                      id: "minSum"
                    }, null, 2), [
                      [_vModelText, _ctx.form.minSum],
                      [_directive_maska]
                    ])
                  ]),
                  _: 1
                }, 8, ["errors"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.limitsFieldsVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.helper.trans("labels.max_sum")) + ":", 1),
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_FormInputWrapper, {
                  errors: _ctx.getErrors(`maxSum`)
                }, {
                  default: _withCtx((parentProps) => [
                    _withDirectives(_createElementVNode("input", {
                      class: _normalizeClass([parentProps.class, "form-control"]),
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.maxSum) = $event)),
                      "data-maska": "9.########",
                      "data-maska-tokens": "9:[0-9]:multiple",
                      inputmode: "decimal",
                      type: "text",
                      id: "maxSum"
                    }, null, 2), [
                      [_vModelText, _ctx.form.maxSum],
                      [_directive_maska]
                    ])
                  ]),
                  _: 1
                }, 8, ["errors"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.form.type === _ctx.Direction.PAY_IN)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.helper.trans("labels.group_payment_option")), 1),
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_FormInputWrapper, {
                  errors: _ctx.getErrors(`paymentOptions`)
                }, {
                  default: _withCtx((parentProps) => [
                    _createVNode(_component_Multiselect, {
                      id: "paymentOptions",
                      class: _normalizeClass(["multiselect-sm", parentProps.class]),
                      modelValue: _ctx.form.paymentOptions,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.paymentOptions) = $event)),
                      options: _ctx.store.getters['currencyMethods/options'](),
                      "custom-label": (opt) => _ctx.helper.trans(`payment_options.${opt}`),
                      multiple: true,
                      "select-label": "Select",
                      placeholder: _ctx.helper.trans('labels.payment_options')
                    }, null, 8, ["modelValue", "options", "custom-label", "class", "placeholder"])
                  ]),
                  _: 1
                }, 8, ["errors"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.receiptsHintFeatureEnabled && _ctx.form.type === _ctx.Direction.PAY_OUT)
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.helper.trans("labels.pay_out_receipts_hint")) + ":", 1),
              _createElementVNode("div", _hoisted_26, [
                _createVNode(_component_FormInputWrapper, {
                  errors: _ctx.getErrors(`payOutReceiptsHint`)
                }, {
                  default: _withCtx((parentProps) => [
                    _withDirectives(_createElementVNode("input", {
                      class: _normalizeClass([parentProps.class, "form-control"]),
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.payOutReceiptsHint) = $event)),
                      type: "text",
                      maxlength: "255",
                      id: "payOutReceiptsHint"
                    }, null, 2), [
                      [_vModelText, _ctx.form.payOutReceiptsHint]
                    ])
                  ]),
                  _: 1
                }, 8, ["errors"]),
                _createElementVNode("small", _hoisted_27, _toDisplayString(_ctx.helper.trans("labels.pay_out_receipts_hint_help")), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.reuseMinCapFeatureEnabled && _ctx.form.type === _ctx.Direction.PAY_IN)
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.helper.trans("labels.reuse_min_cap")), 1),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.reuseMinCapEnabled) = $event)),
                    class: "form-check-input",
                    type: "checkbox",
                    id: "reuseMinCapEnabled"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.form.reuseMinCapEnabled]
                  ])
                ]),
                _createVNode(_component_FormInputWrapper, {
                  errors: _ctx.getReuseMinCapErrors()
                }, {
                  default: _withCtx((parentProps) => [
                    _createVNode(_component_CurrencyAmountMapInput, {
                      modelValue: _ctx.form.reuseMinCaps,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.reuseMinCaps) = $event)),
                      disabled: !_ctx.form.reuseMinCapEnabled,
                      class: _normalizeClass(parentProps.class)
                    }, null, 8, ["modelValue", "disabled", "class"])
                  ]),
                  _: 1
                }, 8, ["errors"]),
                _createElementVNode("small", _hoisted_32, _toDisplayString(_ctx.helper.trans("labels.reuse_min_cap_hint")), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.helper.trans("labels.is_hidden")), 1),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.isHidden) = $event)),
                class: "form-check-input",
                type: "checkbox",
                id: "isHidden"
              }, null, 512), [
                [_vModelCheckbox, _ctx.form.isHidden]
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}